import { getCurrentLanguage } from 'utils/src/getCurrentLanguage';
import { apiClient } from '../../../../apps/crossword-maker/src/shared/apiClient';
import { IWordApiEntity } from './Word.api.types';

export interface ICopyWordFromCrosswordBookPayload {
	crosswordBookWordIds: string[];
}

export type TCopyFromCrosswordBook = (
	data: ICopyWordFromCrosswordBookPayload
) => Promise<IWordApiEntity[]>;

export const copyFromCrosswordBook: TCopyFromCrosswordBook = async (data) => {
	const language = getCurrentLanguage();

	const response = await apiClient().post<IWordApiEntity[]>(
		`/rest/${language}/word-clue/from-crossword-book`,
		data
	);

	return response.data;
};
